import React from 'react';

const What = () =>{
    return(
        <div>
            <div className="my-5" id="what-is">
                <h4 className="text-2xl font-medium mb-5">What Is CodeOne?</h4>
                <p className="pt-4 text-justify">CodeOne is a student and alumni joint organization. CodeOne primarily handles the day to day fulfilment of SMAKONE technological needs. 
                From maintaining student organization website to building specialized apps such as ticket sales app for SMAKONE events. CodeOne is also a learning 
                community where together you can get guidance on anything coding related from learning programming languages, building applications and even do 
                some data science. Joining CodeOne will allow you to work on various projects that will help you build your portfolio. CodeOne is also connected with 
                alumni studying and working at prestigious institutions all over the world, who would definitely love to share with you a thing or two about a career 
                in computer science, applying to your dream university, or getting your first internship.</p>
            </div>
            <div>
              <hr/>
            </div>
        </div>
    )
}
export default What